import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { LegalLinks } from "@faire/retailer-visitor-shared/components/Footer/LegalLinks";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Button } from "@faire/web--source/slate/Button";
import { Opacity } from "@faire/web--source/slate/Color";
import { Column, HorizontalLine, Row } from "@faire/web--source/slate/Layout";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import * as React from "react";
import styled from "styled-components";
export var MakerSignUpWrapper = function(param) {
    var children = param.children;
    var isSSR = useIsSSR();
    var BRAND_SIGN_UP_BACKGROUND_IMAGE = optimizeImageUrl({
        url: "https://cdn.faire.com/fastly/a2433fe4b864a396996e79b48f5b39939f1353d65ea2cb4439823e87dc29e3eb.png"
    }, isSSR);
    var backgroundImageUrl = BRAND_SIGN_UP_BACKGROUND_IMAGE;
    return /*#__PURE__*/ _jsx(Wrapper, {
        align: "center",
        children: /*#__PURE__*/ _jsxs(FormWrapper, {
            children: [
                /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                    desktopAndAbove: /*#__PURE__*/ _jsx(ImageColumn, {
                        $backgroundImageUrl: backgroundImageUrl,
                        "data-test-id": "apply-page-image-column",
                        children: /*#__PURE__*/ _jsx(AbsoluteButton, {
                            variant: "tertiary",
                            linkTo: home(),
                            children: /*#__PURE__*/ _jsx(FaireLogo, {
                                size: 100
                            })
                        })
                    }),
                    mobile: null
                }),
                /*#__PURE__*/ _jsxs(ContentColumn, {
                    align: {
                        mobileAndAbove: "flex-start",
                        tabletAndAbove: undefined
                    },
                    style: {
                        maxWidth: "650px"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                            mobile: /*#__PURE__*/ _jsx(MobileLogoButton, {
                                variant: "tertiary",
                                linkTo: home(),
                                children: /*#__PURE__*/ _jsx(FaireLogo, {
                                    size: 100
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(ContentWrapper, {
                            children: children
                        }),
                        /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                            tabletAndAbove: /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx(HorizontalLine, {}),
                                    /*#__PURE__*/ _jsx(Row, {
                                        style: {
                                            padding: getSpacing("4x", 0, "4x", "4x")
                                        },
                                        children: /*#__PURE__*/ _jsx(LegalLinks, {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var Wrapper = styled(Column).withConfig({
    componentId: "sc-cd1ece15-0"
})([
    "min-height:100vh;background-color:",
    "",
    ";"
], Decorative.tint.neutral, Opacity.O_50);
var FormWrapper = styled(Row).attrs({
    align: "flex-start",
    flex: 1
}).withConfig({
    componentId: "sc-cd1ece15-1"
})([
    "width:100%;"
]);
var ContentWrapper = styled(Column).withConfig({
    componentId: "sc-cd1ece15-2"
})([
    "padding:",
    ";@media (max-width:1106px){padding:",
    ";}",
    "{padding:96px 104px;}",
    "{padding:",
    ";}",
    "{padding:0;}"
], getSpacing("9x", "10x"), getSpacing("9x", "5x"), responsiveMediaQueries.xLargeAndAbove, responsiveMediaQueries.tablet, getSpacing("3x", "4x"), responsiveMediaQueries.mobile);
var ContentColumn = styled(Column).attrs({
    flex: 1,
    justify: "space-between"
}).withConfig({
    componentId: "sc-cd1ece15-3"
})([
    "width:50vw;height:100vh;overflow-y:auto;",
    "{height:100%;width:100%;}"
], responsiveMediaQueries.mobile);
var ImageColumn = styled(ContentColumn).withConfig({
    componentId: "sc-cd1ece15-4"
})([
    "width:50vw;max-width:50vw;height:100vh;background-image:url(",
    ");background-repeat:no-repeat;background-size:cover;background-position:center;position:relative;"
], function(props) {
    return props.$backgroundImageUrl;
});
var AbsoluteButton = styled(Button).withConfig({
    componentId: "sc-cd1ece15-5"
})([
    "position:absolute;top:48px;left:48px;"
]);
var MobileLogoButton = styled(Button).withConfig({
    componentId: "sc-cd1ece15-6"
})([
    "padding:",
    ";"
], getSpacing("3x", "3x", "1x"));
